import { gsap } from "gsap";
export default function (){

        $(function (){
            if(!$('body').hasClass('page-home')){
                return;
            }

            let gradientArrows, yellowArrows, whiteArrows,
                yellowBigArrow, yellowArrow, whiteArrow,
                whiteBigArrow, gradientArrow, gradientBigArrow;

            gradientArrows = gsap.to('#gradient-arrows', {
                rotate: -108,
                duration: 2.5,
                paused: true,
                onComplete: gradientReverseFunction,
                ease: 'linear',

            })

            yellowArrows = gsap.to('#yellow-arrows',{
                rotate: -108,
                x: 25,
                y: 125,
                scale: .65,
                duration: 2.5,
                paused : true,
                onComplete: yellowReverseFunction,
                ease: 'linear',
            })
            whiteArrows = gsap.to('#white-arrows', {
                keyframes: [
                    {
                        rotate: -108,
                        x: 100,
                        y: -60,
                        scale: .85,
                        duration: 2.5
                    },
                ],
                paused : true,
                onComplete: whiteReverseFunction,
                ease: "linear",
            })

            yellowBigArrow = gsap.to('#Path_3',
                {

                    scale: 0.488,
                    duration: 2.5,
                    paused : true,
                    onComplete: yellowBigArrowReverseFunction,
                    ease: 'linear'
                }
            )


            yellowArrow = gsap.from('#Path_4',
                {
                    scale: .8,
                    duration: 2.5,
                    delay: 1,
                    paused : true,
                    onComplete: yellowArrowReverseFunction,
                    ease: 'linear'
                })
            whiteArrow = gsap.to('#Path_6', {
                scale: .4,
                duration: 2.5,
                paused : true,
                onComplete: whiteArrowReverseFunction,
                ease: 'linear'
            })
            gradientBigArrow = gsap.to('#Path_12', {
                attr: {
                    width: 110.33,
                    height: 95.55,
                },
                duration: 2.5,
                paused : true,
                onComplete: gradientBigArrowReverseFunction,
                ease: 'linear'
            })
            gradientArrow = gsap.to('#Path_13', {
                attr: {
                    width: 211.8,
                    height: 183.42,
                },
                // scale: 1.5,
                duration: 2.5,
                paused : true,
                onComplete: gradientArrowReverseFunction,
                ease: 'linear'
            })

            function whiteReverseFunction(){
                whiteArrows.reverse();
            }
            function gradientReverseFunction(){
                gradientArrows.reverse();
            }
            function yellowReverseFunction(){
                yellowArrows.reverse();
            }
            function yellowBigArrowReverseFunction(){
                yellowBigArrow.reverse();
            }
            function yellowArrowReverseFunction(){
                yellowArrow.reverse();
            }
            function whiteArrowReverseFunction(){
                whiteArrow.reverse();
            }
            function gradientBigArrowReverseFunction(){
                gradientBigArrow.reverse();
            }
            function gradientArrowReverseFunction(){
                gradientArrow.reverse();
            }

            function startAnimation(){
                gradientArrows.play();
                yellowArrows.play();
                whiteArrows.play();
                whiteArrow.play();
                yellowArrow.play();
                yellowBigArrow.play();
                gradientArrow.play();
                gradientBigArrow.play();
            }
            // startAnimation();

            function stopAnimation(){
                // Restart all animations
                gradientArrows.restart();
                yellowArrows.restart();
                whiteArrows.restart();
                whiteArrow.restart();
                yellowArrow.restart();
                yellowBigArrow.restart();
                gradientArrow.restart();
                gradientBigArrow.restart();
                // Stop all animations
                gradientArrows.pause();
                yellowArrows.pause();
                whiteArrows.pause();
                whiteArrow.pause();
                yellowArrow.pause();
                yellowBigArrow.pause();
                gradientArrow.pause();
                gradientBigArrow.pause();

            }

            let job = document.querySelector('#job');
            let emp = document.querySelector('#emp');

            // Default variables
            document.querySelector('#gradient-arrows').style.zIndex = -1;
            document.querySelector('#white-arrows').style.zIndex = -1;
            document.querySelector('#yellow-arrows').style.zIndex = -1;

            // Default Opacity
            document.querySelector('#gradient-arrows').style.opacity = 0;
            document.querySelector('#white-arrows').style.opacity = 0;
            document.querySelector('#yellow-arrows').style.opacity = 0;

            job.addEventListener('mouseenter', function(){
                // Z index
                job.style.zIndex = 999;
                document.querySelector('#gradient-arrows').style.zIndex = 9;
                document.querySelector('#white-arrows').style.zIndex = 9;
                document.querySelector('#yellow-arrows').style.zIndex = 9;

                startAnimation();
                // Opacity
                document.querySelector('#gradient-arrows').style.opacity = 1;
                document.querySelector('#white-arrows').style.opacity = 1;
                document.querySelector('#yellow-arrows').style.opacity = 1;
                emp.style.opacity = ".4";
                document.querySelector('.animation__arrows').style.opacity = "0";
                // Change Logo
                const image = document.getElementById('logo');
                let res = image.src.split('/');
                res.forEach( (i) => { if (i == "logo.svg"){ return image.src = '/images/TASCLogoHover.svg' } else { return image.src = 'images/logo.svg'; } } );
                // Change colors
                document.querySelector('#app').style.backgroundColor = "#005f83";
                document.querySelector('#Path_70').style.fill = "#fff"
                document.querySelector('#Path_71').style.fill = "#fff"
                document.querySelectorAll(".text-blue").forEach(e => e.classList.add('text-white'));
                document.querySelectorAll('.section__white').forEach(e => e.style.backgroundColor = '#005f83');
                document.querySelector('header').classList.add('bg-none-important');
            });
            job.addEventListener('mouseleave', function(){
                // Z index
                job.style.zIndex = 0;
                document.querySelector('#gradient-arrows').style.zIndex = -1;
                document.querySelector('#white-arrows').style.zIndex = -1;
                document.querySelector('#yellow-arrows').style.zIndex = -1;

                stopAnimation();
                // Opacity
                document.querySelector('#gradient-arrows').style.opacity = 0;
                document.querySelector('#white-arrows').style.opacity = 0;
                document.querySelector('#yellow-arrows').style.opacity = 0;
                emp.style.opacity = "1";
                document.querySelector('.animation__arrows').style.opacity = "1";
                // Change logo image
                const image = document.getElementById('logo');
                let res = image.src.split('/');
                res.forEach( (i) => { if (i == "TASCLogoHover.svg"){ return image.src = '/images/logo.svg' } else { return image.src = 'images/TASCLogoHover.svg'; } } );
                // Change colors
                document.querySelector('#Path_70').style.fill = "#005f83"
                document.querySelector('#Path_71').style.fill = "#005f83"
                document.querySelector('#app').style.backgroundColor = "#fff";
                document.querySelectorAll(".text-blue").forEach(e => e.classList.remove('text-white'));
                document.querySelectorAll('.section__white').forEach(e => e.style.backgroundColor = '#fff');
                document.querySelector('header').classList.remove('bg-none-important');
            })
            emp.addEventListener('mouseenter', function(){
                // Top for bottom
                document.querySelector('#allArrows').style.position = "relative";
                document.querySelector('#allArrows').style.top = "17em";
                document.querySelector('#allArrows').style.left = "3em";
                // Z index
                emp.style.zIndex = 999;
                document.querySelector('#gradient-arrows').style.zIndex = 9;
                document.querySelector('#white-arrows').style.zIndex = 9;
                document.querySelector('#yellow-arrows').style.zIndex = 9;

                startAnimation();
                // Opacity
                document.querySelector('#gradient-arrows').style.opacity = 1;
                document.querySelector('#white-arrows').style.opacity = 1;
                document.querySelector('#yellow-arrows').style.opacity = 1;
                job.style.opacity = ".4";
                document.querySelector('.animation__arrows').style.opacity = "0";
                // Change Logo
                const image = document.getElementById('logo');
                let res = image.src.split('/');
                res.forEach( (i) => { if (i == "logo.svg"){ return image.src = '/images/TASCLogoHover.svg' } else { return image.src = 'images/logo.svg'; } } );
                // Change colors
                document.querySelector('#app').style.backgroundColor = "#005f83";
                document.querySelector('#Path_70').style.fill = "#fff"
                document.querySelector('#Path_71').style.fill = "#fff"
                document.querySelectorAll(".text-blue").forEach(e => e.classList.add('text-white'));
                document.querySelectorAll('.section__white').forEach(e => e.style.backgroundColor = '#005f83');
                document.querySelector('header').classList.add('bg-none-important');
            });
            emp.addEventListener('mouseleave', function(){
                // Top for bottom
                document.querySelector('#allArrows').style.position = "static";
                document.querySelector('#allArrows').style.top = "auto";
                document.querySelector('#allArrows').style.left = "auto";
                // Z index
                emp.style.zIndex = 0;
                document.querySelector('#gradient-arrows').style.zIndex = -1;
                document.querySelector('#white-arrows').style.zIndex = -1;
                document.querySelector('#yellow-arrows').style.zIndex = -1;

                stopAnimation();
                // Opacity
                document.querySelector('#gradient-arrows').style.opacity = 0;
                document.querySelector('#white-arrows').style.opacity = 0;
                document.querySelector('#yellow-arrows').style.opacity = 0;
                job.style.opacity = "1";
                document.querySelector('.animation__arrows').style.opacity = "1";
                // Change logo image
                const image = document.getElementById('logo');
                let res = image.src.split('/');
                res.forEach( (i) => { if (i == "TASCLogoHover.svg"){ return image.src = '/images/logo.svg' } else { return image.src = 'images/TASCLogoHover.svg'; } } );
                // Change colors
                document.querySelector('#Path_70').style.fill = "#005f83"
                document.querySelector('#Path_71').style.fill = "#005f83"
                document.querySelector('#app').style.backgroundColor = "#fff";
                document.querySelectorAll(".text-blue").forEach(e => e.classList.remove('text-white'));
                document.querySelectorAll('.section__white').forEach(e => e.style.backgroundColor = '#fff');
                document.querySelector('header').classList.remove('bg-none-important');
            })

        })
}
